import { el, mount } from "redom"
import { backToApp } from "./appFunctions.js"
import { display } from "../records/helpers/layoutwithapp.js"
import type { AudioRecord } from "#/types"

// TODO: combine processBack and processBackBtn
export const processBack = window.location.search.includes("App") ? () => backToApp() : () => window.history.back()
//  set route for back button
// NOTE: If coming right from the app, it returns true. Otherwise, it has window history back in web view.
export const processBackBtn = () => {
    const str = window.location.search
    if (str.includes("backToPrev")) window.history.back()
    else backToApp()
}

const isMacLike = () => navigator.platform.match(/(Mac|iPhone|iPod|iPad)/i) != null
const isIOS = () => navigator.platform.match(/(iPhone|iPod|iPad)/i) != null
export const isAppleDevice = () => (isMacLike() || isIOS())

export const escapeHtml = (unsafe: string): string =>
    unsafe.replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;")

export const showPageNotFound = () => showContent(true)
export const showRecordContent = () => showContent(false)

const showContent = (isNoPage: boolean) => {
    const notFoundEl = document.getElementById("not-found");
    if (notFoundEl) notFoundEl.onclick = () => window.location.href = "/records"
    display("record-app", true);
    display("templateBackground", !isNoPage);
    display("not-found", isNoPage);
    display("allContent", !isNoPage);
    display("records-page", !isNoPage);
}

export const buildBadge = (file: AudioRecord): DocumentFragment => {
    const badges: DocumentFragment = document.createDocumentFragment()
    file.badges.forEach(badge => mount(badges, el("span.badge recordTagBadge", { style: "margin-right: 5px;" }, badge)))
    if (file.bitrate > 64) mount(badges, el("span.badge recordTagBadge", { style: "background-color: white;" }, `${file.bitrate}k`))
    return badges
}

export const isDarkTheme = (): boolean => window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches

export const debounce = (ms: number = 100, fn: (...args: any) => void) => {
    let timerId = -1;
    return (...args: any) => {
        clearTimeout(timerId)
        const promiseForFunc = new Promise((resolve) => {
            //@ts-ignore
            timerId = setTimeout(resolve, ms);
        });
        return promiseForFunc.then(() => fn(...args))
    }
}